(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.ticking = false;
    }

    connectedCallback() {
      this.headerSection = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.animationStyle = this.getAttribute('data-animation-style') || 'slide';
      this.scrollTrigger = Number(this.getAttribute('data-scroll-trigger') || 80);
      this.header = this.querySelector('.cds-header');
      this.predictiveSearch = this.querySelector('predictive-search');

      if (!this.headerSection) return;

      this.headerSection.classList.add(`gksen-animation-${this.animationStyle}`);
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
        this.showHeader();
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderHeight() {
      if (this.headerSection) {
        document.documentElement.style.setProperty('--header-height', `${this.headerSection.offsetHeight}px`);
      }
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;

      window.requestAnimationFrame(() => {
        this.updateHeader();
        this.ticking = false;
      });
    }

    updateHeader() {
      if (!this.headerSection || this.stickyType === 'none') return;

      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollingDown = currentScrollTop > this.lastScrollTop;
      const isPastTrigger = currentScrollTop > this.scrollTrigger;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (isPastTrigger) {
        this.headerSection.classList.add('gksen-header-scrolled');
      } else {
        this.headerSection.classList.remove('gksen-header-scrolled');
      }

      if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
        this.showHeader();
        this.lastScrollTop = Math.max(currentScrollTop, 0);
        return;
      }

      if (this.stickyType === 'hide-on-scroll') {
        if (isPastTrigger) {
          this.hideHeader();
        } else {
          this.showHeader();
        }

        this.lastScrollTop = Math.max(currentScrollTop, 0);
        return;
      }

      if (this.stickyType === 'on-scroll-up') {
        if (isScrollingDown && isPastTrigger) {
          this.hideHeader();
        } else {
          this.showHeader();
        }

        if (currentScrollTop <= 5) {
          this.resetHeader();
        }
      }

      this.lastScrollTop = Math.max(currentScrollTop, 0);
    }

    hideHeader() {
      this.headerSection.classList.add('gksen-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    showHeader() {
      this.headerSection.classList.remove('gksen-header-hidden');
    }

    resetHeader() {
      this.headerSection.classList.remove('gksen-header-hidden', 'gksen-header-scrolled');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
